"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var React = require('react');
var react_1 = require('react');
var AppBar_1 = require('material-ui/AppBar');
var Paper_1 = require('material-ui/Paper');
var RaisedButton_1 = require('material-ui/RaisedButton');
var RadioButton_1 = require('material-ui/RadioButton');
var pokemon_1 = require('../pokemon');
var AutoComplete_1 = require('material-ui/AutoComplete');
var firebase = require('firebase');
var Dialog_1 = require('material-ui/Dialog');
var FlatButton_1 = require('material-ui/FlatButton');
var Fingerprint = require('fingerprintjs2');
var Table_1 = require('material-ui/Table');
var numeral = require('numeral');
var Tabs_1 = require('material-ui/Tabs');
require('./egg.scss');
var EggApp = (function (_super) {
    __extends(EggApp, _super);
    function EggApp() {
        _super.call(this);
        this.exclude = [151, 150, 146, 145, 144, 132].map(function (n) { return n.toString(); });
        this.size = [35, 42];
        this.scale = {
            '2': 1,
            '5': 2,
            '10': 3
        };
        this.pokemon = pokemon_1.pokemon;
        this.sizes = Object.keys(this.scale);
        var table = {};
        for (var _i = 0, _a = this.sizes; _i < _a.length; _i++) {
            var size = _a[_i];
            table[size] = {
                total: 0,
                count: {}
            };
        }
        this.state = {
            size: '2',
            submitted: false,
            limit: false,
            table: table
        };
        this.fingerprint = new Fingerprint();
    }
    EggApp.prototype.componentDidMount = function () {
        var _this = this;
        this.ref = firebase.database().ref('eggs');
        var pub = this.ref.child('public');
        var _loop_1 = function(size) {
            pub.child(size).on('value', function (snapshot) {
                var table = _this.state.table;
                var list = table[size];
                var count = list.count;
                snapshot.forEach(function (item) {
                    if (_this.exclude.indexOf(item.key) < 0) {
                        count[item.key] = item.val();
                    }
                    return false;
                });
                list.total = 0;
                for (var id in count) {
                    list.total += count[id];
                }
                _this.set('table', table);
            });
        };
        for (var _i = 0, _a = this.sizes; _i < _a.length; _i++) {
            var size = _a[_i];
            _loop_1(size);
        }
        document.title = 'Pokemon Go Egg Reporter';
    };
    EggApp.prototype.eggStyle = function (size) {
        var scale = this.scale[size];
        return {
            width: scale * this.size[0] + "px",
            height: scale * this.size[1] + "px"
        };
    };
    EggApp.prototype.set = function (name, value) {
        var state = {};
        state[name] = value;
        this.setState(state);
    };
    EggApp.prototype.change = function (name) {
        var _this = this;
        return function (event, selected) {
            _this.set(name, selected);
        };
    };
    EggApp.prototype.updatePokemon = function (pokemon) {
        this.setState({
            pokemon: this.pokemon.map[pokemon].id
        });
    };
    EggApp.prototype.getPokemon = function (map) {
        var data = [];
        var count = map.count;
        for (var id in count) {
            var c = count[id];
            var pokemon_2 = this.pokemon.list[+id];
            data.push({
                element: React.createElement(Table_1.TableRow, {key: id}, React.createElement(Table_1.TableRowColumn, null, React.createElement("img", {src: pokemon_2.img}), pokemon_2.name), React.createElement(Table_1.TableRowColumn, null, numeral(c / map.total).format('0.000%'))),
                count: c
            });
        }
        data.sort(function (a, b) {
            return b.count - a.count;
        });
        return data.map(function (d) { return d.element; });
    };
    EggApp.prototype.simplifyString = function (str) {
        return str.trim().toLowerCase();
    };
    EggApp.prototype.filter = function (searchText, key) {
        var simplifiedSearch = this.simplifyString(searchText);
        var simplifiedKey = this.simplifyString(key);
        return simplifiedSearch !== '' && simplifiedKey.indexOf(simplifiedSearch) === 0;
    };
    EggApp.prototype.submit = function () {
        var _this = this;
        if (!this.state.pokemon) {
            return;
        }
        var storage = window.localStorage.getItem('eggSubmitted');
        var submitted = storage ? JSON.parse(storage) : [];
        var current = Date.now();
        var within = 1000 * 60 * 5; // within 1 minutes
        var total = 0;
        for (var _i = 0, submitted_1 = submitted; _i < submitted_1.length; _i++) {
            var time = submitted_1[_i];
            if (time + within > current) {
                total++;
            }
        }
        if (total > 5) {
            return this.setState({
                limit: true
            });
        }
        this.set('sending', true);
        this.fingerprint.get(function (result, components) {
            var size = _this.state.size;
            var poke = _this.state.pokemon.toString();
            var ref = _this.ref.child('private').ref.push({
                size: size,
                pokemon: poke,
                added: firebase.database['ServerValue'].TIMESTAMP,
                fingerprint: {
                    result: result,
                    components: components
                }
            }, function () {
                _this.ref.child('public').child(size).child(poke).ref.transaction(function (count) { return (count || 0) + 1; }, function () {
                    _this.setState({
                        size: '2',
                        pokemon: null,
                        sending: false,
                        submitted: true
                    });
                    submitted.push(Date.now());
                    window.localStorage.setItem('eggSubmitted', JSON.stringify(submitted));
                    _this.radios.setState({
                        selected: '2'
                    });
                    _this.search.setState({
                        searchText: ''
                    });
                });
            });
        });
    };
    EggApp.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", {className: "egg"}, React.createElement(AppBar_1.default, {title: "Pokemon Go Egg Reporter"}), React.createElement(Dialog_1.default, {title: "Egg Report Success", actions: React.createElement(FlatButton_1.default, {label: "Ok", primary: true, onTouchTap: function () { return _this.set('submitted', false); }}), modal: false, open: this.state.submitted, onRequestClose: function () { return _this.set('submitted', false); }}, "Thank you for submitting your Egg Report"), React.createElement(Dialog_1.default, {title: "Woah there!", actions: React.createElement(FlatButton_1.default, {label: "Ok", primary: true, onTouchTap: function () { return _this.set('limit', false); }}), modal: false, open: this.state.limit, onRequestClose: function () { return _this.set('limit', false); }}, "You have made too many requests in a short time. Please try again later."), React.createElement("div", {className: "container"}, React.createElement("div", {className: "wrapper"}, React.createElement(Paper_1.default, {className: "selector"}, React.createElement("div", {className: "incubator"}, React.createElement("img", {style: this.eggStyle(this.state.size), src: "img/egg.png"})), React.createElement("div", {className: "holder"}, React.createElement(RadioButton_1.RadioButtonGroup, {ref: function (r) { _this.radios = r; }, className: "choose", name: "size", defaultSelected: "2", onChange: this.change('size')}, this.sizes.map(function (s, i) { return React.createElement(RadioButton_1.RadioButton, {key: i, value: s, label: s + "km"}); })))), React.createElement("div", {className: "fields"}, React.createElement("div", {className: "pokemon"}, React.createElement(AutoComplete_1.default, {ref: function (s) { _this.search = s; }, floatingLabelText: "Pokemon from Egg", filter: this.filter.bind(this), dataSource: this.pokemon.names, errorText: this.state.pokemon ? '' : 'Must be a Pokemon', maxSearchResults: 5, onNewRequest: this.updatePokemon.bind(this)}), React.createElement("img", {src: this.state.pokemon ? this.pokemon.list[this.state.pokemon].img : '', style: { visibility: this.state.pokemon ? 'visible' : 'hidden' }})), React.createElement("div", {className: "result"}, React.createElement(RaisedButton_1.default, {disabled: !!this.state.sending, label: "Report Egg Result", onClick: this.submit.bind(this)})))), React.createElement(Paper_1.default, {className: "tabs", style: { visibility: this.state.table && this.state.table[this.sizes[0]].total > 10 ? 'visible' : 'hidden' }}, React.createElement(Tabs_1.Tabs, null, this.sizes.map(function (s, i) {
            return React.createElement(Tabs_1.Tab, {key: i, label: s + "km"}, React.createElement(Table_1.Table, {height: "calc(100vh - 64px - 48px)", fixedHeader: true}, React.createElement(Table_1.TableHeader, {displaySelectAll: false, adjustForCheckbox: false}, React.createElement(Table_1.TableRow, null, React.createElement(Table_1.TableHeaderColumn, null, "Pokemon"), React.createElement(Table_1.TableHeaderColumn, null, "Percent"))), React.createElement(Table_1.TableBody, {showRowHover: true, displayRowCheckbox: false}, _this.getPokemon(_this.state.table[s]))));
        }))))));
    };
    return EggApp;
}(react_1.Component));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = EggApp;



/*****************
 ** WEBPACK FOOTER
 ** ./src/egg/egg.tsx
 ** module id = 591
 ** module chunks = 0
 **/